import { createHelpPanelLoader } from "@amzn/awsui-app-layout-loader";
import { createWidgetizedHelpPanel, HelpPanelImplementation } from "./implementation";

export const InternalHelpPanel = createWidgetizedHelpPanel(
  createHelpPanelLoader({ Fallback: HelpPanelImplementation }),
);
